/** PROPS */
import BASE_INPUT_DEFAULT_PROPS from '@/components/base_components/generic-relations-wrapper/configuration/BASE_INPUT_DEFAULT_PROPS';
/** COMPONENTS **/
import { RelatedUnit } from '@/components/base_components/generic-relations-wrapper/types/RelatedUnit';
import { RelatedInput } from '@/components/base_components/generic-relations-wrapper/types/RelatedInput';

/** HELPERS */
import { getAttributesIds } from '@/components/base_components/generic-relations-wrapper/configuration/shared-helper-function';
import i18n from '@/language/i18n'

import ProductPicker from '@/components/global_components/pickers/product_picker/ProductPicker';
import DevicePicker from '@/components/global_components/pickers/device_picker/DevicePicker';
import WorkCategoryTreeFilter from '@/components/global_components/filters/category_filter/WorkCategoryTreeFilter';
import WorkCategoryAttributeFilter from '@/components/global_components/filters/category_attribute_filter/WorkCategoryAttributeFilter';
import WorkflowMultiActionSelectWrapper from '@/components/base_components/workflow/workflow_inputs/workflow_action_picker/WorkflowMultiActionSelectWrapper';

/********************************************************
 * Override these file with customer implementation to  *
 * customize Textblocks                                 *
 *******************************************************/

const CONFIG = Object.freeze([
  new RelatedUnit(
    i18n.t('Common.activities'),
    [
      new RelatedInput(1, 'w-form-autocomplete-lazy', 'activitytype', {
        label: i18n.t('Common.activity'),
        path: 'activities/types',
        getData: (response) => response.data.data,
        itemText: 'data.label',
        itemValue: 'id',
        vid: 'activitytype',
        ...BASE_INPUT_DEFAULT_PROPS,
      }),
    ],
    { cols: '12', md: '6' }
  ),
  new RelatedUnit(
    i18n.t('Common.workflowSteps'),
    [
      new RelatedInput(1, WorkflowMultiActionSelectWrapper, 'workflowaction', {
        label: i18n.t('Common.workflow'),
        vid: 'workflowaction',
        withFormField: false,
        ...BASE_INPUT_DEFAULT_PROPS,
      }),
    ],
    { cols: '12', md: '6' }
  ),

  new RelatedUnit(
    i18n.t('Common.products'),
    [
      new RelatedInput(
        1,
        WorkCategoryTreeFilter,
        'category',
        {
          label: i18n.t('Common.category'),
          itemValue: 'id',
          hasFilterOption: false,
          selectParents: true,
          watchParams: [
            {
              model: 'productattribute',
              getParams: (attributes) => ({
                attributes: getAttributesIds(attributes),
              }),
            },
          ],
          vid: 'productCategories',
          ...BASE_INPUT_DEFAULT_PROPS,
          onlyFirstChild: false
        },
        4,
        false
      ),
      new RelatedInput(
        1,
        WorkCategoryAttributeFilter,
        'productattribute',
        {
          label: i18n.t('Common.attribute'),
          withFalseValue: false,
          vid: 'productattribute',
          watchParams: [
            { model: 'category', getParams: (id) => ({ categories: id }) },
          ],
          ...BASE_INPUT_DEFAULT_PROPS,
        },
        4,
        false
      ),
      new RelatedInput(
        2,
        ProductPicker,
        'product',
        {
          label: i18n.t('Common.product'),
          path: 'products',
          itemText: 'label',
          itemValue: 'id',
          vid: 'product',
          ...BASE_INPUT_DEFAULT_PROPS,
        },
        4
      ),
      new RelatedInput(
        3,
        DevicePicker,
        'device',
        {
          label: i18n.t('Common.device'),
          path: 'devices',
          itemText: 'label',
          itemValue: 'id',
          vid: 'device',
          createDeviceButton: false,
          ...BASE_INPUT_DEFAULT_PROPS,
        },
        4
      ),
    ],
    { cols: '12' }
  ),
]);

export default CONFIG;
